import { Component, Inject } from '@angular/core';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FieldLayoutDefault } from '../../../models/field/field-layout-default.model';
import { FieldLayoutViewModelService } from '../../../services/field-layout-view-model.service';
import { FieldLayoutViewModel } from '../../../models/field/field-layout-view-model.model';
import { FieldLayoutDefaultType } from '../../../models/field/field-layout-default-type.enum';
import { RoleGuid } from '../../../models/role.model';

@Component({
    selector: 'lex-manage-defaults',
    templateUrl: './manage-defaults.component.html',
    styleUrls: ['./manage-defaults.component.scss'],
    standalone: false
})
export class ManageDefaultsComponent extends KeyHandlerDirective {

	sharedLayouts: FieldLayoutViewModel[] = [];
	pinnedLayouts: FieldLayoutViewModel[] = [];
	recentLayouts: FieldLayoutViewModel[] = [];

	standardRoleId: string = RoleGuid.StandardFeatureSet;
	reviewRoleId: string = RoleGuid.DocReviewFeatureSet;
	limitedRoleId: string = RoleGuid.LimitedFeatureSet;

	existingLayoutDefaults: FieldLayoutDefault[] = new Array<FieldLayoutDefault>();

	standardLayoutDisplay: string;
	reviewLayoutDisplay: string;
	limitedLayoutDisplay: string;
	standardLayoutCoding: string;
	reviewLayoutCoding: string;
	limitedLayoutCoding: string;

	constructor(private dialogRef: MatDialogRef<ManageDefaultsComponent>, @Inject(MAT_DIALOG_DATA) data, private fieldLayoutViewModelService: FieldLayoutViewModelService) {
		super();
		this.sharedLayouts = data.links.shared.map(l => l.layout);
		this.pinnedLayouts = data.links.pinned.map(l => l.layout);
		this.recentLayouts = data.links.recent.map(l => l.layout);

		fieldLayoutViewModelService.getDefaultLayouts().subscribe((data) => {
			this.existingLayoutDefaults = data;
			this.setDefaults();
		});
	}

	setDefaults() {
		this.existingLayoutDefaults.forEach(fld => {
			switch (fld.accountRoleId) {
				case this.standardRoleId: {
					if (fld.defaultType == FieldLayoutDefaultType.Display)
						this.standardLayoutDisplay = fld.fieldLayoutId;
					else if (fld.defaultType == FieldLayoutDefaultType.Coding)
						this.standardLayoutCoding = fld.fieldLayoutId
					break;
				}
				case this.reviewRoleId: {
					if (fld.defaultType == FieldLayoutDefaultType.Display)
						this.reviewLayoutDisplay = fld.fieldLayoutId;
					if (fld.defaultType == FieldLayoutDefaultType.Coding)
						this.reviewLayoutCoding = fld.fieldLayoutId;
					break;
				}
				case this.limitedRoleId: {
					if (fld.defaultType == FieldLayoutDefaultType.Display)
						this.limitedLayoutDisplay = fld.fieldLayoutId
					if (fld.defaultType == FieldLayoutDefaultType.Coding)
						this.limitedLayoutCoding = fld.fieldLayoutId;
					break;
				}
			}
		})
	}

	ok(): void {
		this.updateLayout(this.standardLayoutDisplay, this.standardRoleId, FieldLayoutDefaultType.Display);
		this.updateLayout(this.reviewLayoutDisplay, this.reviewRoleId, FieldLayoutDefaultType.Display);
		this.updateLayout(this.limitedLayoutDisplay, this.limitedRoleId, FieldLayoutDefaultType.Display);
		this.updateLayout(this.standardLayoutCoding, this.standardRoleId, FieldLayoutDefaultType.Coding);
		this.updateLayout(this.reviewLayoutCoding, this.reviewRoleId, FieldLayoutDefaultType.Coding);
		this.updateLayout(this.limitedLayoutCoding, this.limitedRoleId, FieldLayoutDefaultType.Coding);

		const fieldLayoutIds: string[] = [this.standardLayoutDisplay, this.reviewLayoutDisplay, this.limitedLayoutDisplay, this.standardLayoutCoding, this.reviewLayoutCoding, this.limitedLayoutCoding];
		this.dialogRef.close(fieldLayoutIds);
	}

	updateLayout(layoutId: string, roleId: string, type: FieldLayoutDefaultType) {
		if (layoutId) {
			this.fieldLayoutViewModelService.updateDefaultLayout(new FieldLayoutDefault(layoutId, roleId, type)).subscribe();
		}

		// If incoming ID is undefined, remove the existing layout for that AccountRoleId and Type
		const existingLayout = this.existingLayoutDefaults.find(ld => ld.accountRoleId == roleId && ld.defaultType == type);
		if (!layoutId && existingLayout)
			this.fieldLayoutViewModelService.removeDefault(existingLayout.fieldLayoutDefaultId).subscribe();
	}
}
